import {
  DialogEventHandlerArgSuccess,
  DialogEventHandlerArgError,
} from '../types/dialog'

export const isDialogEventHandlerArgSuccess = (
  arg: unknown
): arg is DialogEventHandlerArgSuccess => {
  if (typeof arg !== 'object' || arg === null) {
    return false
  }

  const obj = arg as Record<string, unknown>

  return (
    typeof obj.message === 'string' &&
    (obj.origin === undefined || typeof obj.origin === 'string')
  )
}

export const isDialogEventHandlerArgError = (
  arg: unknown
): arg is DialogEventHandlerArgError => {
  if (typeof arg !== 'object' || arg === null) {
    return false
  }

  const obj = arg as Record<string, unknown>

  return typeof obj.error === 'number'
}
